import React, { useState } from 'react'
import PropTypes from 'prop-types'
// import React, { useState } from 'react';


export default function TextForm(props) {

    const handleUpClick = () => {
        // console.log("handleUpClick")
        let newtext = text.toUpperCase();
        setText(newtext);

    }
    const handleLoClick = () => {
        // console.log("handleUpClick")
        let newtext = text.toLowerCase();
        setText(newtext);

    }
    const handleClClick = () => {
        // console.log("handleUpClick")
        let newtext = '';
        setText(newtext);

    }

    const handleOnChange = (event) => {
        console.log("handleOnChange")
        setText(event.target.value)
    }

    const [text, setText] = useState('');

    return (
        <>
            <div className="container">

                <div className="mb-3">
                    <h3>{props.heading}</h3>
                    {/* <label for="exampleFormControlTextarea1" className="form-label">{props.heading}</label> */}
                    <textarea className="form-control my-3" id="mytext" value={text} onChange={handleOnChange} rows="8"></textarea>
                    <button className="btn btn-primary mx-2" onClick={handleUpClick}>Convert To UpperCase</button>
                    <button className="btn btn-primary mx-2" onClick={handleLoClick}>Convert To LowerCase</button>
                    {/* <button className="btn btn-primary mx-2" onClick={handleCoClick}>Copy To Clipboard</button> */}
                    <button className="btn btn-primary mx-2" onClick={handleClClick}>Clear Text</button>



                </div>
            </div>
            <div className="container my-3">
                <h3>Your Text Summery</h3>
                <p>{text.split(" ").length} word and {text.length} characters.</p>
                <p>{0.008 * text.split(" ").length} Minutes to read.</p>
                <h3>Preview</h3>
                <p>{text.length>0?text:'Enter Something to see preview'}</p>

            </div>
        </>
    )
}


TextForm.propTypes = {
    heading: PropTypes.string
};

TextForm.defaultProps = {
    heading: 'Input Statement For Text'
};
